// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__loadingContainer___vlX5D{width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1.5rem}.styles-module__loaderContainer___2k81u{display:flex;justify-content:center;align-items:center;padding:3px}.styles-module__loadingText___1BPDg{font-size:18px;line-height:22px}.styles-module__imageContainer___2U1GM{width:300px;height:120px;display:flex;justify-content:center;align-items:center}.styles-module__imageContainer___2U1GM img{width:80%}.styles-module__imageContainer___2U1GM div{text-align:center}\n", ""]);
// Exports
exports.locals = {
	"loadingContainer": "styles-module__loadingContainer___vlX5D",
	"loaderContainer": "styles-module__loaderContainer___2k81u",
	"loadingText": "styles-module__loadingText___1BPDg",
	"imageContainer": "styles-module__imageContainer___2U1GM"
};
module.exports = exports;
